import React from 'react'
import IconBase from './IconBase'

const Person = props =>
  <IconBase viewBox="0 0 35 40" {...props}>
    <ellipse cx="17.5" cy="11.9" rx="11.9" ry="11.9"/>
    <path d="m17.5 25.7c-7.1 0-13.6 3.6-17.5 9.5 0 0 3.2 4.8 17.7 4.8 14 0 17.2-4.8 17.2-4.8-3.8-5.9-10.4-9.5-17.4-9.5z"/>
  </IconBase>

export default Person
